export const LOGIN_FIELD_NAMES = {
  MOBILE: "mobile",
  COUNTRY_CODE: "countryCode",
  PASSWORD: "password",
};

export const LOGIN_INPUT_TYPES = {
  TEL: "tel",
  PASSWORD: "password",
  TEXT: "text",
};

export const LOGIN_ICONS = {
  PHONE: "phone",
  LOCK: "lock",
  VISIBILITY: "visibility",
  VISIBILITY_OFF: "visibilityOff",
  INVENTORY: "inventory",
  LOCAL_OFFER: "localOffer",
  CLOUD_UPLOAD: "cloudUpload",
};

export const LOGIN_FEATURE_VARIANT = {
  PACKAGES: "packages",
  COUPONS: "coupons",
  UPLOADS: "uploads",
};

export const LOGIN_ARIA_LABELS = {
  LOGO: "Infinity Learn",
  SHOW_PASSWORD: "Show password",
  HIDE_PASSWORD: "Hide password",
  COUNTRY_CODE: "Country dialing code",
};

export const LOGIN_COPY = {
  BRAND_NAME: "Minerva",
  WELCOME_PREFIX: "Welcome to",
  PLATFORM_SUBTITLE: "Package, Coupon & Upload Management Platform",
  SIGN_IN_HEADING: "Sign in to your account",
  SIGN_IN_SUBHEADING: "Enter your credentials to access Minerva",
  MOBILE_LABEL: "Mobile Number",
  MOBILE_PLACEHOLDER: "Enter your mobile number",
  PASSWORD_LABEL: "Password",
  PASSWORD_PLACEHOLDER: "Enter your password",
  SIGN_IN_BUTTON: "Sign In",
  SUPPORT_TEXT: "Don't have an account? Contact support team.",
  SUCCESS_MESSAGE: "Login Successful",
  DEFAULT_ERROR_MESSAGE: "Invalid username or password. Please try again.",
  COUNTRY_LOADING: "Loading countries…",
  COUNTRY_LOAD_FAILED: "Could not load countries",
  COUNTRY_NONE_AVAILABLE: "No countries available",
  COUNTRY_RETRY: "Retry",
};

export const LOGIN_VALIDATION_MESSAGES = {
  COUNTRY_REQUIRED: "Country code is required",
  MOBILE_REQUIRED: "Mobile number is required",
  MOBILE_INVALID: "Enter a valid mobile number for the selected country",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_MIN_LENGTH: "Password must contain at least 8 characters",
};

export const LOGIN_FEATURES = [
  {
    id: LOGIN_FEATURE_VARIANT.PACKAGES,
    icon: LOGIN_ICONS.INVENTORY,
    title: "Packages",
    description: "Create, manage and track all your packages.",
  },
  {
    id: LOGIN_FEATURE_VARIANT.COUPONS,
    icon: LOGIN_ICONS.LOCAL_OFFER,
    title: "Coupons",
    description: "Create, update and track coupons.",
  },
  {
    id: LOGIN_FEATURE_VARIANT.UPLOADS,
    icon: LOGIN_ICONS.CLOUD_UPLOAD,
    title: "Uploads",
    description: "Bulk upload packages and coupons.",
  },
];

export const LOGIN_VISIBLE_COUNTRY_CODES = [
  "IND",
  // "BHR",
  // "KWT",
  // "QAT",
  // "OMN",
  // "SAU",
  // "ARE",
  // "USA",
];

export const LOGIN_INITIAL_VALUES = {
  [LOGIN_FIELD_NAMES.MOBILE]: "",
  [LOGIN_FIELD_NAMES.COUNTRY_CODE]: "",
  [LOGIN_FIELD_NAMES.PASSWORD]: "",
};

export const LOGIN_PASSWORD_MIN_LENGTH = 8;
